import {Provider, TooltipProviderProps as RadixTooltipProviderProps} from '@radix-ui/react-tooltip';

export type TooltipProviderProps = RadixTooltipProviderProps;

export function TooltipProvider(props: TooltipProviderProps) {
	return <Provider {...props}/>;
}
